export const brpGroup = {
  siteName: "brp",
  senderName: "BRP Group",
  logo: "/static/warbox_logo.png",
  name: "BRP Group",
  api: {
    production: "https://api.warbox.io/api/v1",
    staging: "https://staging.api.warbox.io/api/v1",
    development: "http://localhost:5000/api/v1",
  },
  client: "brp-group",
};
